<template>
    <PersonalInformationForm ref="pIF" :submit="submit" :user="user" />
</template>

<script>
import { mapActions } from 'vuex'
import { UserIdentifyType } from '@/constants'
import PersonalInformationForm from './../components/PersonalInformationForm'

export default {
    name: 'UserAccount',

    components: {
        PersonalInformationForm
    },

    props: {
        user: {
            default() {
            }
        }
    },
    data() {
        return {
            UserIdentifyType
        };
    },

    methods: {
        ...mapActions({
            edit: 'user/edit',
            setShowLoading: 'loadingComponent/setShowLoading',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
        }),
        submit() {
            this.setShowLoading()
            this.resetMsg()

            const data = {
                id: this.user.id,
                telephone: this.user.telephone,
                city: this.user.city,
                national_code: this.user.national_code,
                identity_type: this.user.identity_type,
                postal_code: this.user.postal_code,
                address: this.user.address,
                province: this.user.province,
                township: this.user.township,
                avatar: this.user.avatar,
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                registration_number: this.user.registration_number,
                economic_code: this.user.economic_code,
                legal_name: this.user.legal_name,
                birth_certificate: this.user.birth_certificate,
                national_card: this.user.national_card,
                representative_name: this.user.representative_name,
                representative_phone: this.user.representative_phone,
                representative_email: this.user.representative_email,
                // email: this.user.email,
                // phone: this.user.phone,
            }

            this.edit(data).then(() => {
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('user.updated'),
                    type: 'success'
                })
            })
            .catch(result => {
                if (result.data) {
                    this.$refs.pIF.$refs.form.setErrors(result.data)
                }

                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.' + result.tag),
                    type: 'danger'
                })
            })
        }
    }
}
</script>